<script setup lang="ts">
import TextInput from '@/components/common/inputs/TextInput.vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'

interface ProspectionButton {
  label: string
  text: string
  color: string
}

defineProps<{
  buttons: ProspectionButton[]
}>()

const emit = defineEmits<{
  (e: 'add'): void
  (e: 'remove', index: number): void
  (e: 'save'): void
}>()
</script>

<template>
  <div class="space-y-3">
    <p class="text-sm text-base-content/60">
      Configurez jusqu'à 5 boutons de raccourcis réutilisables sur les champs texte.
    </p>

    <div v-if="!buttons.length" class="text-sm text-base-content/60 italic">
      Aucun bouton configuré.
    </div>

    <div
      v-for="(btn, index) in buttons"
      :key="index"
      class="border border-base-200 rounded-lg p-3 space-y-2"
    >
      <div class="flex items-center justify-between">
        <span class="text-sm font-semibold">Bouton {{ index + 1 }}</span>
        <button class="btn btn-ghost btn-xs text-error" type="button" @click="emit('remove', index)">
          Supprimer
        </button>
      </div>
      <div class="flex items-end gap-3">
        <div class="w-32 shrink-0">
          <TextInput label="Label" v-model="btn.label" placeholder="Ex: Note" />
        </div>
        <div class="flex-1">
          <TextInput label="Texte" v-model="btn.text" placeholder="Ex: À rappeler demain..." />
        </div>
        <div class="shrink-0 flex flex-col gap-1">
          <span class="text-xs font-semibold text-base-content/70">Couleur</span>
          <input
            type="color"
            v-model="btn.color"
            class="w-10 h-[2.5rem] rounded cursor-pointer border border-base-300 p-0.5 bg-transparent"
          />
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between pt-1">
      <ButtonDaisy
        v-if="buttons.length < 5"
        text="Ajouter un bouton"
        variant="outline"
        size="sm"
        type="button"
        @click="emit('add')"
      />
      <span v-else class="text-sm text-base-content/60 italic">Maximum de 5 boutons atteint.</span>
      <ButtonDaisy
        text="Sauvegarder"
        variant="primary"
        size="sm"
        type="button"
        @click="emit('save')"
      />
    </div>
  </div>
</template>
